/**
 * Format a US-style phone number as "(xxx) xxx-xxxx" when the raw input has
 * exactly 10 digits. Anything else (international, partial, garbled) passes
 * through unchanged — better to render the contractor's raw input than to
 * mangle an unfamiliar pattern.
 *
 * Shared by Settings (on-blur reformat), Review (live preview), and the PDF
 * generator (contact strip + bill-to block).
 */
export function formatPhone(raw) {
  if (raw === null || raw === undefined) return "";
  const s = String(raw);
  const digits = s.replace(/\D/g, "");
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return s;
}

export default formatPhone;
